import { render, staticRenderFns } from "./MiraScreenHeader.vue?vue&type=template&id=380fed3e&scoped=true&"
import script from "./MiraScreenHeader.vue?vue&type=script&lang=ts&"
export * from "./MiraScreenHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MiraScreenHeader.vue?vue&type=style&index=0&id=380fed3e&scoped=true&lang=css&"
import style1 from "./MiraScreenHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fed3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow,VSpacer})
